import { Banner } from '../store/schema/Banner';
import { getStore } from '../store/appModuleStore';

export const getShownBanner = (): Banner => getStore().shownBanner;
